var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon3Bullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5F6B76",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6,
    r: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 20,
    y2: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 18,
    r: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon3Bullet);
export default __webpack_public_path__ + "static/media/settings-icon-3-bullet.4e9a96afb0441b0fbfb2ba1c88557c01.svg";
export { ForwardRef as ReactComponent };